export default "/fonts/vendor/fontsource-roboto/files/roboto-all-400-normal.woff?b5a0a0df312d3423493b163e9675488c";